import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import prepareHeaders from '../utils/prepareHeaders'

export const featureFlagsApi = createApi({
  reducerPath: 'featureFlags',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getFeatureFlags: builder.query({
      keepUnusedDataFor: Infinity,
      query: () => '/tools/feature-flags',
      transformResponse: (featureFlags) =>
        (Array.isArray(featureFlags) ? featureFlags : []).reduce(
          (result, { feature, enabled }) => ({
            [feature]: enabled,
            ...result,
          }),
          {},
        ),
    }),
  }),
})

export const { useGetFeatureFlagsQuery } = featureFlagsApi

export const useFeatureFlag = (feature) => {
  const { data = {} } = useGetFeatureFlagsQuery()

  return !!data[feature]
}

export const useAnyFeatureFlag = (...features) => {
  const { data = {} } = useGetFeatureFlagsQuery()

  return features.some((feature) => !!data[feature])
}

export const useSecureFeatureFlag = () => useAnyFeatureFlag('secure-licensing', 'test-account')
